var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
let logging = false;
exports.logging = logging;
exports.setLogging = _logging => {
  logging = _logging;
};
exports.log = (...args) => logging ? console.log.apply(this || _global, args) : null;
export default exports;